// import { useDefaultsFromURLSearch } from 'state/swap/hooks'
import { useTranslation } from '@pancakeswap/localization'
import { Balance, Box, Button, ChevronDownIcon, CloseIcon, Dots, Flex, FlexGap, IconButton, QuestionHelper, Text, useMatchBreakpoints, useModal } from '@pancakeswap/uikit'
import BubbleChart from 'components/BubbleChart'
import Page from 'components/Layout/Page'
import { CurrencyLogo } from 'components/Logo'
import { useCurrency } from 'hooks/Tokens'
import useNativeCurrency from 'hooks/useNativeCurrency'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import Percent from 'views/V3Info/components/Percent'
import { TokenData } from 'views/V3Info/types'
import { formatAmount, formatDollarAmount } from 'views/V3Info/utils/numbers'

import { useUserQuickBuyAmount } from '@pancakeswap/utils/user'
import CustomLoader from 'components/Loader/CustomLoader'
import { useAccount } from 'wagmi'
import Price from 'components/Price'
import { safeGetAddress } from 'utils'
import axios from 'axios'
import SwapPage from '../Page'
import { V3SwapForm } from './V3Swap'
import { FilterModal, TokenFilter } from './components/FilterModal'
import { useAllTokens, usePeggingPrices } from './hooks/useTokens'
import { StyledInputCurrencyWrapper } from './styles'
import { QuickSwapModal } from './components/QuickSwapModal'

const Header = styled(Flex)`
  gap: 4px;
  align-items: center;
  cursor: pointer;
`

const Row = styled.div`
  display: grid;
  column-gap: 16px;
  grid-template-columns: 200px repeat(4, 1fr) 4em 1fr;
  border-bottom: 1px solid #FFF3;
  padding: 18px 0;
  align-items: center;
  ${({ theme }) => theme.mediaQueries._lg} {
    column-gap: 8px;
    grid-template-columns: 120px 1fr 1fr 1fr;
  }
`

const TableWrapper = styled(Box)`
  width: 100%;
  // ${({ theme }) => theme.mediaQueries._lg} {
  //   width: fit-content;
  // }
`

const BubbleIcon = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7 8C7 8.55228 6.55228 9 6 9C5.44772 9 5 8.55228 5 8C5 7.44772 5.44772 7 6 7C6.55228 7 7 7.44772 7 8ZM9 8C9 9.65685 7.65685 11 6 11C4.34315 11 3 9.65685 3 8C3 6.34315 4.34315 5 6 5C7.65685 5 9 6.34315 9 8ZM11 17C11 18.1046 10.1046 19 9 19C7.89543 19 7 18.1046 7 17C7 15.8954 7.89543 15 9 15C10.1046 15 11 15.8954 11 17ZM13 17C13 19.2091 11.2091 21 9 21C6.79086 21 5 19.2091 5 17C5 14.7909 6.79086 13 9 13C11.2091 13 13 14.7909 13 17Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M16 11C17.6569 11 19 9.65685 19 8C19 6.34315 17.6569 5 16 5C14.3431 5 13 6.34315 13 8C13 9.65685 14.3431 11 16 11ZM16 13C18.7614 13 21 10.7614 21 8C21 5.23858 18.7614 3 16 3C13.2386 3 11 5.23858 11 8C11 10.7614 13.2386 13 16 13Z" />
  </svg>
)

const ListIcon = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M16.4213 0.857117H7.579C6.47862 0.858251 5.42364 1.29588 4.64555 2.07396C3.86747 2.85204 3.42985 3.90703 3.42871 5.0074V18.9925C3.42985 20.0929 3.86747 21.1479 4.64555 21.926C5.42364 22.7041 6.47862 23.1417 7.579 23.1428H16.4213C17.5217 23.1417 18.5766 22.7041 19.3547 21.926C20.1328 21.1479 20.5704 20.0929 20.5716 18.9925V5.0074C20.5704 3.90703 20.1328 2.85204 19.3547 2.07396C18.5766 1.29588 17.5217 0.858251 16.4213 0.857117ZM18.8573 18.9925C18.8566 19.6384 18.5997 20.2576 18.143 20.7143C17.6863 21.171 17.0671 21.4279 16.4213 21.4285H7.579C6.93314 21.4279 6.31393 21.171 5.85724 20.7143C5.40055 20.2576 5.14368 19.6384 5.143 18.9925V5.0074C5.14368 4.36154 5.40055 3.74233 5.85724 3.28564C6.31393 2.82895 6.93314 2.57208 7.579 2.5714H16.4213C17.0671 2.57208 17.6863 2.82895 18.143 3.28564C18.5997 3.74233 18.8566 4.36154 18.8573 5.0074V18.9925Z" />
    <path d="M15.4286 6.85712H8.5715C8.34417 6.85712 8.12615 6.94742 7.96541 7.10817C7.80466 7.26891 7.71436 7.48693 7.71436 7.71426C7.71436 7.94159 7.80466 8.15961 7.96541 8.32035C8.12615 8.4811 8.34417 8.5714 8.5715 8.5714H15.4286C15.656 8.5714 15.874 8.4811 16.0347 8.32035C16.1955 8.15961 16.2858 7.94159 16.2858 7.71426C16.2858 7.48693 16.1955 7.26891 16.0347 7.10817C15.874 6.94742 15.656 6.85712 15.4286 6.85712Z" />
    <path d="M15.4286 11.1429H8.5715C8.34417 11.1429 8.12615 11.2332 7.96541 11.3939C7.80466 11.5547 7.71436 11.7727 7.71436 12C7.71436 12.2274 7.80466 12.4454 7.96541 12.6061C8.12615 12.7669 8.34417 12.8572 8.5715 12.8572H15.4286C15.656 12.8572 15.874 12.7669 16.0347 12.6061C16.1955 12.4454 16.2858 12.2274 16.2858 12C16.2858 11.7727 16.1955 11.5547 16.0347 11.3939C15.874 11.2332 15.656 11.1429 15.4286 11.1429Z" />
    <path d="M12.0001 15.4286H8.5715C8.34417 15.4286 8.12615 15.5189 7.96541 15.6796C7.80466 15.8404 7.71436 16.0584 7.71436 16.2857C7.71436 16.5131 7.80466 16.7311 7.96541 16.8918C8.12615 17.0526 8.34417 17.1429 8.5715 17.1429H12.0001C12.2274 17.1429 12.4454 17.0526 12.6062 16.8918C12.7669 16.7311 12.8572 16.5131 12.8572 16.2857C12.8572 16.0584 12.7669 15.8404 12.6062 15.6796C12.4454 15.5189 12.2274 15.4286 12.0001 15.4286Z" />
  </svg>
)

const FilterIcon = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M18.5857 5H5.41411C4.52321 5 4.07704 6.07714 4.70701 6.70711L9.70701 11.7071C9.89454 11.8946 9.9999 12.149 9.9999 12.4142V16.5C9.9999 16.8148 10.1481 17.1111 10.3999 17.3L13.1999 19.4C13.5295 19.6472 13.9999 19.412 13.9999 19V12.4142C13.9999 12.149 14.1053 11.8946 14.2928 11.7071L19.2928 6.70711C19.9228 6.07714 19.4766 5 18.5857 5Z" strokeWidth="2" strokeLinecap="round" />
  </svg>
)

const QuickIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.99017 12.3531L11.1755 1.98241C11.2148 1.90376 11.3334 1.93174 11.3334 2.01968V7.71791C11.3334 8.01268 11.6311 8.21425 11.9048 8.10477L14.4825 7.07368C14.8383 6.93139 15.1813 7.3042 15.0099 7.64689L9.82459 18.0176C9.78527 18.0963 9.66672 18.0683 9.66672 17.9803V12.2821C9.66672 11.9873 9.369 11.7858 9.09531 11.8952L6.51759 12.9263C6.16186 13.0686 5.81882 12.6958 5.99017 12.3531Z" fill="#EEA23E" />
  </svg>
)

const Options = styled(FlexGap)`
  align-items: center;
  border: 2px solid #423B51;
  border-radius: 12px;
  padding: 4px;
  button {
    background: transparent;
    height: 40px;
    width: 40px;
    &.selected {
      background: #423B51;
      border-radius: 8px;
    }
  }
`

const QuickButton = styled(Button)`
  display: flex;
  gap: 4px;
  padding: 4px;
  height: auto;
  width: fit-content;
  margin: auto;
  border-radius: 10px;
  border-width: 1px;
  &:disabled {
    opacity: 0.5;
  }
`

const Section = styled.div`
  cursor: pointer;
`

const Icon = ({ color, size }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.99996 12.3337V8.33366M8.99996 6.33366V6.32699M16.3333 9.00033C16.3333 13.0504 13.05 16.3337 8.99996 16.3337C4.94987 16.3337 1.66663 13.0504 1.66663 9.00033C1.66663 4.95024 4.94987 1.66699 8.99996 1.66699C13.05 1.66699 16.3333 4.95024 16.3333 9.00033Z" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
};

const TokenRow = ({ tokenData }: { tokenData: any }) => {
  const router = useRouter()
  const { address } = useAccount()
  const native = useNativeCurrency()
  const currency = useCurrency(tokenData.address)
  const { isDesktop, isMobile } = useMatchBreakpoints()
  // const [auditData, setAuditData] = useState<any>()

  const { data: prices } = usePeggingPrices()

  const pegRatio = useMemo(() => {
    if (!prices)
      return undefined
    const price = prices[safeGetAddress(tokenData.address)]
    if (!price || !tokenData.price)
      return undefined
    return price / tokenData.price
  }, [prices, tokenData])

  const navigateTokenDetail = () => {
    // if (tokenData.address.toLowerCase() === native.wrapped.address.toLowerCase())
    //   return
    router.push(`/token/${tokenData.address}`)
  }

  const [quickBuyAmount] = useUserQuickBuyAmount()

  const [onPresentQuickModal] = useModal(
    <QuickSwapModal currency={currency} />, true, false, `quickswap-modal-${tokenData.address}`
  )

  return <Row>
    <FlexGap style={{ cursor: "pointer" }} gap="8px" alignItems="center" onClick={navigateTokenDetail}>
      <CurrencyLogo currency={currency} />
      <FlexGap flexDirection="column" width={["88px", "88px", "168px"]}>
        <Text fontSize={14} width="100%">{currency?.name ?? tokenData.name}</Text>
        <Text fontSize={14} bold color="textDisabled">{currency?.symbol ?? tokenData.symbol}</Text>
      </FlexGap>
    </FlexGap>
    <Section onClick={navigateTokenDetail}>
      <Percent fontSize="14px" value={tokenData.priceChange} />
      <Price fontSize={14} value={tokenData.price} prefix="$" />
    </Section>
    <Section onClick={navigateTokenDetail}>
      <Text fontSize={14}>{formatDollarAmount(tokenData.volume1d)}</Text>
    </Section>
    {
      isDesktop
        ? <>
          <Section onClick={navigateTokenDetail}>
            {/* <Percent fontSize="14px" value={tokenData.marketCapChange} /> */}
            <Text fontSize={14}>{formatDollarAmount(tokenData.marketCap)}</Text>
          </Section>
          <Section onClick={navigateTokenDetail}><Text onClick={navigateTokenDetail} fontSize={14}>{formatDollarAmount(tokenData.liquidity)}</Text></Section>
          {/* <Section onClick={navigateTokenDetail} style={{ textAlign: 'center' }}><YesNo value={auditData?.mintable} /></Section>
          <Section onClick={navigateTokenDetail} style={{ textAlign: 'center' }}><YesNo value={auditData?.transferPausable} /></Section>
          <Section onClick={navigateTokenDetail} style={{ textAlign: 'center' }}><YesNo value={auditData?.lpBurned} /></Section> */}
          <Section onClick={navigateTokenDetail}>
            {
              pegRatio && tokenData.address.toLowerCase() !== native.wrapped.address.toLowerCase() && tokenData.address.toLowerCase() !== "0xd6c31ba0754c4383a41c0e9df042c62b5e918f6d"
                ? <Balance fontSize={14} decimals={0} unit="x" value={Number(pegRatio)} />
                : '-'
            }
          </Section>
        </>
        : <></>
    }

    {tokenData.address.toLowerCase() !== native.wrapped.address.toLowerCase() && (
      <QuickButton variant="secondary" onClick={onPresentQuickModal} disabled={!address}>
        <QuickIcon />
        {
          !isMobile &&
          <Text fontSize={12} mr="4px" color={address ? "text" : "textSubtle"}>{formatAmount(quickBuyAmount, 2)}</Text>
        }
        {!isMobile && <CurrencyLogo currency={native} size='16px' />}
      </QuickButton>)}


  </Row>
}

export default function Swap() {
  const { t } = useTranslation()

  // const { address: account } = useAccount()
  const { isDesktop } = useMatchBreakpoints()
  const [mode, setMode] = useState('list')
  const [filter, setFilter] = useState<TokenFilter>({ query: '', ranges: [] })
  const [sortField, setSortField] = useState("liquidity")
  const [sortDirection, setSortDirection] = useState<boolean>(true)

  // useDefaultsFromURLSearch()
  const { data: allTokens } = useAllTokens('v3', filter, sortField, sortDirection)

  const tokens = useMemo(() => {
    if (!allTokens)
      return []
    return Object.values(allTokens)
      .map((token) => token)
      .filter(Boolean)
  }, [allTokens])

  const sortedTokens = useMemo(() => {
    return tokens
      ? tokens
        .sort((a, b) => {
          if (a && b) {
            return a[sortField as keyof TokenData] > b[sortField as keyof TokenData]
              ? (sortDirection ? -1 : 1) * 1
              : (sortDirection ? -1 : 1) * -1
          }
          return -1
        })
      : []
  }, [tokens, sortField, sortDirection])

  const toggleSort = useCallback((field: string) => {
    if (sortField === field)
      setSortDirection(!sortDirection)
    else {
      setSortField(field)
      setSortDirection(true)
    }
  }, [sortField, sortDirection])

  const [onPresentFilterModal] = useModal(
    <FilterModal filter={filter} setFilter={setFilter} />,
    true,
    true,
    `filter-modal`
  )

  // const applyFilters = (_tokens: any[], _filter: any): any[] => {
  //   return _tokens.filter(token => {
  //     if (!filter)
  //       return true
  //     // Search query filter - match against name or symbol
  //     if (_filter.query && _filter.query.trim() !== '') {
  //       const query = _filter.query.toLowerCase();
  //       const name = (token.name || '').toLowerCase();
  //       const symbol = (token.symbol || '').toLowerCase();
  //       const address = (token.address || '').toLowerCase();

  //       if (!name.includes(query) && !symbol.includes(query) && !address.includes(query)) {
  //         return false;
  //       }
  //     }

  //     // Market cap filters
  //     if (_filter.minMarketCap && !Number.isNaN(Number(_filter.minMarketCap))) {
  //       if (token.marketCap < Number(_filter.minMarketCap)) {
  //         return false;
  //       }
  //     }

  //     if (_filter.maxMarketCap && !Number.isNaN(Number(_filter.maxMarketCap))) {
  //       if (token.marketCap > Number(_filter.maxMarketCap)) {
  //         return false;
  //       }
  //     }

  //     // Liquidity _filters (using tvlUSD as liquidity)
  //     if (_filter.minLiquidity && !Number.isNaN(Number(_filter.minLiquidity))) {
  //       if (token.tvlUSD < Number(_filter.minLiquidity)) {
  //         return false;
  //       }
  //     }

  //     if (_filter.maxLiquidity && !Number.isNaN(Number(_filter.maxLiquidity))) {
  //       if (token.tvlUSD > Number(_filter.maxLiquidity)) {
  //         return false;
  //       }
  //     }

  //     // Volume _filters
  //     if (_filter.minVolume && !Number.isNaN(Number(_filter.minVolume))) {
  //       if (token.volumeUSD < Number(_filter.minVolume)) {
  //         return false;
  //       }
  //     }

  //     if (_filter.maxVolume && !Number.isNaN(Number(_filter.maxVolume))) {
  //       if (token.volumeUSD > Number(_filter.maxVolume)) {
  //         return false;
  //       }
  //     }

  //     // If the token passed all filter conditions
  //     return true;
  //   });
  // };

  return (
    <Page>
      <SwapPage>
        <StyledInputCurrencyWrapper>
          <V3SwapForm />
        </StyledInputCurrencyWrapper>
      </SwapPage>
      <TableWrapper mt={4} mx="auto">
        {sortedTokens && sortedTokens.length >= 1 && (
          <FlexGap gap="1em" justifyContent="center" alignItems="center" mb={2}>
            <Options>
              <IconButton className={mode === 'list' ? 'selected' : ''} onClick={() => setMode('list')}>
                <ListIcon color={mode === 'list' ? "white" : '#877A9F'} />
              </IconButton>
              <IconButton className={mode === 'bubble' ? 'selected' : ''} onClick={() => setMode('bubble')}>
                <BubbleIcon color={mode === 'bubble' ? "white" : '#877A9F'} />
              </IconButton>
            </Options>
            <Options>
              <FlexGap gap="8px" height="40px" alignItems="center" px="12px" style={{ cursor: 'pointer' }} onClick={onPresentFilterModal}>
                <FilterIcon color="white" />
                <Text fontSize={12} color="white" fontWeight="700">{t('Filter')}</Text>
                <ChevronDownIcon color="#877A9F" />
                {
                  (filter.query || filter.ranges.length > 0) &&
                  <CloseIcon color="#877A9F" onClick={(e) => {
                    e.stopPropagation()
                    setFilter({ query: '', ranges: [] })
                  }} />
                }
              </FlexGap>
            </Options>
          </FlexGap>)}
        {
          sortedTokens && sortedTokens.length >= 1
            ? (
              mode === "list"
                ? <>
                  <Row>
                    <Header onClick={() => toggleSort('name')}>
                      <Text color="textSubtle" fontSize={12}>{t("Token/Age")}</Text>
                      {
                        sortField === 'name' &&
                        (sortDirection ? '↓' : '↑')
                      }
                    </Header>
                    <Header onClick={() => toggleSort('price')}>
                      <Text color="textSubtle" fontSize={12}>{t("Price")}</Text>
                      {
                        sortField === 'price' &&
                        (sortDirection ? '↓' : '↑')
                      }
                    </Header>
                    <Header onClick={() => toggleSort('volume1d')}>
                      <Text color="textSubtle" fontSize={12}>{t("24h Volume")}</Text>
                      {
                        sortField === 'volume1d' &&
                        (sortDirection ? '↓' : '↑')
                      }
                    </Header>
                    {
                      isDesktop
                        ? <>
                          <Header onClick={() => toggleSort('marketCap')}>
                            <Text color="textSubtle" fontSize={12}>{t("Mkt Cap")}</Text>
                            {
                              sortField === 'marketCap' &&
                              (sortDirection ? '↓' : '↑')
                            }
                          </Header>
                          <Header onClick={() => toggleSort('liquidity')}>
                            <Text color="textSubtle" fontSize={12}>{t("Liquidity")}</Text>
                            {
                              sortField === 'liquidity' &&
                              (sortDirection ? '↓' : '↑')
                            }
                          </Header>
                          {/* <Header>
                            <Text color="textSubtle" fontSize={12}>{t("Mint Auth Disabled")}</Text>
                          </Header>
                          <Header>
                            <Text color="textSubtle" fontSize={12}>{t("Freeze Auth Disabled")}</Text>
                          </Header>
                          <Header>
                            <Text color="textSubtle" fontSize={12}>{t("LP Burned")}</Text>
                          </Header> */}
                          <Header>
                            <Text color="textSubtle" fontSize={12}>{t("To Peg")}</Text>
                          </Header>
                        </>
                        : <></>
                    }
                    <Header justifyContent="center">
                      <Text color="textSubtle" fontSize={12}>{t("Quick Buy")}</Text>
                      <QuestionHelper placement="top"
                        icon={<Icon color="#B7ADD1" size={16} />}
                        text={
                          <div>
                            <Text fontSize={13} color="textSubtle">⚡️ Instantly buy a with your pre-set amount of $PLS</Text>
                            <Text fontSize={13} color="textSubtle">(You can change your pre-set $PLS amount in Wallet Settings in the top right corner)</Text>
                          </div>
                        }
                      />
                    </Header>
                  </Row>
                  {
                    sortedTokens.map(tokenData =>
                      <TokenRow key={tokenData.address} tokenData={tokenData} />
                    )
                  }
                </>
                : <BubbleChart tokens={sortedTokens} />
            )
            : <Flex justifyContent="center" flexDirection="column" alignItems="center">
              <Text fontSize={24} color="textSubtle">{t("Retrieving tokens list, please wait...")}</Text>
              <CustomLoader />
            </Flex>
        }
      </TableWrapper>
    </Page>
  )
}
